export class MoveArticlesBetweenBlocksData {
  private _articleGuid: string;
  private _fromBlockGuid: string;
  private _fromBmkStructure: string;
  private _toBlockGuid: string;
  private _toBmkStructure: string;

  public constructor(articleGuid: string, fromBlockGuid: string, fromBmkStructure: string, toBlockGuid: string, toBmkStructure: string) {
    this._articleGuid = articleGuid;
    this._fromBlockGuid = fromBlockGuid;
    this._fromBmkStructure = fromBmkStructure;
    this._toBlockGuid = toBlockGuid;
    this._toBmkStructure = toBmkStructure;
  }

  public get articleGuid(): string {
    return this._articleGuid;
  }

  public get fromBlockGuid(): string {
    return this._fromBlockGuid;
  }

  public get toBlockGuid(): string {
    return this._toBlockGuid;
  }

  get toBmkStructure(): string {
    return this._toBmkStructure;
  }

  get fromBmkStructure(): string {
    return this._fromBmkStructure;
  }
}
